import { Component, Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './center-view.component.ajs';

@Directive({
  selector: 'cng-agent-center-view-upgrade',
})
export class AgentCenterViewUpgradeComponent extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-center-view',
  template: '<cng-agent-center-view-upgrade></cng-agent-center-view-upgrade>',
})
export class AgentCenterViewComponent {}
